import type { IEmbedSize } from "~/feature/embed/utils/getEmbedMinSize";

export const getEmbedFitMessage = (
  size: IEmbedSize,
  min: IEmbedSize
): string => {
  const clauses: string[] = [];

  if (size.height < min.height) {
    clauses.push(`${min.height}px of height (now ${size.height})`);
  }

  if (size.width < min.width) {
    clauses.push(`${min.width}px of width (now ${size.width})`);
  }

  return clauses.length ? `Needs at least ${clauses.join(" and ")}` : "";
};
